export default "__VITE_ASSET__77184af1__"